// extracted by mini-css-extract-plugin
export default {"img":"carousel_img__SakbB","carouselShadow":"carousel_carouselShadow__IUGoG","carouselCap":"carousel_carouselCap__i2tLY"};